import { ElementList } from '@/interfaces/administration/administration';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-select-drop-down-list',
  templateUrl: './select-drop-down-list.component.html',
  styleUrls: ['./select-drop-down-list.component.css'],
})
export class SelectDropDownListComponent implements OnInit {

  @Input() title: string = 'Default Title';
  @Input() subTitle: string = 'This a a default subtitle text that you must change.';
  @Input() buttonText: string = 'Default button text';
  @Input() elementList: ElementList[] = [];  // Definir contrato de elementos en el listado
  @Input() gettingDropDownElements: boolean = false;
  @Input() gettingDropDownElementsError: string = 'DEFAULT_VALUE';
  @Input() elementsPerColumn: number = 0;


  @Output() showAddNewListForm = new EventEmitter<boolean>();

  @Output() showEditListForm = new EventEmitter<boolean>();

  searchValue: string = '';


  constructor() { }

  ngOnInit(): void {

  }

  onKey(event: any) {
    this.searchValue = event.target.value;
  }


  onShowFormNewAddList() {
    this.showAddNewListForm.emit();
  }
  onShowFormEditList() {
    this.showEditListForm.emit();
  }
}

